<template>
  <component :is="tagName" :href="hrefLink" class="goods-card-container" :style="{width}">
    <div :style="cardStyle" :class="className">
      <AspectRatio class="goods-card_image" :ratio="ratio">
        <div class="corner-mark" v-if="config.show_corner_mark">
          <svg-icon :name="cornerIcon" v-if="config.corner_mark_type!==4"/>
          <div class="corner-mark_custom" v-else>
            <img :src="config.corner_mark_image" alt="" v-if="config.corner_mark_image">
            <p v-else>角标区域</p>
          </div>
        </div>
        <div class="sell-number" v-if="config.show_sell_number">已售{{data.sell_count}}</div>
        <van-image :src="data.image_url" :fit="fit" width="100%" height="100%"/>
      </AspectRatio>
      <div :class="infoClass" v-if="config.show_title||config.show_price||config.show_origin_price||config.show_buy_btn">
        <div class="goods_card_name" v-if="config.show_title">
          <p class="name" :style="[400,500][config.text_style_type]">{{data.title}}</p>
        </div>
        <div class="goods_card_price" v-if="config.show_price||config.show_origin_price||config.show_buy_btn">
          <div class="price-block">
            <p class="price" v-if="config.show_price">￥{{data.price}}</p>
            <p class="origin-price" v-if="config.show_origin_price">￥{{data.origin_price}}</p>
          </div>
          <BuyBtn :config="config" @click="callBuyAction" :loading="buyLoading" prevent/>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
  import AspectRatio from "@/components/AspectRatio";
  import GoodsCard from '../mixins/GoodsCard';
  import GoodsSku from '../mixins/GoodsSku';
  import BuyBtn from '../BuyBtn';

  export default {
	name: "GoodsCard",
	props: {
	  config: Object,
	  data: Object,
	  index: Number
	},
	mixins: [GoodsCard, GoodsSku],
	components: {AspectRatio, BuyBtn},
	data() {
	  return {};
	},
	created() {
	},
	methods: {},
	computed: {}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .goods-card-container {
    float: left;

    .sell-number {
      font-size: 12px;
      background-color: #FFE7D6;
      display: inline-block;
      margin-right: 5px;

      position: absolute;
      bottom: 10px;
      left: 10px;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      line-height: 18px;
      padding: 0 10px;
      border-radius: 2px;
      white-space: nowrap;
      z-index: 1;
    }

    .goods-card {
      overflow: hidden;
      position: relative;
      box-sizing: border-box;

      &.list {
        height: 120px;
        display: flex;

        .goods-card_image {
          flex-basis: 120px;
          flex-shrink: 0;
        }

        .goods-card_info {
          flex: 1;
          width: calc(100% - 120px);

          .goods_card_name {
            height: 60px;

            .name {
              .limit-line(3);
            }
          }

          div.buy-btn-block {
            top: 15px;
          }
        }
      }

      .corner-mark {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        line-height: 1;

        svg {
          font-size: 40px;
        }

        .corner-mark_custom {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            height: 100%;
            width: 100%;
            object-fit: cover;
          }

          p {
            width: 2em;
            font-size: 12px;
            background-color: rgba(0, 0, 0, 0.08);
            outline: 7px solid rgba(0, 0, 0, 0.08);
          }
        }
      }

      .goods-card_info {
        padding: 10px 10px 0;
        position: relative;

        &.goods-card_align-left {
          text-align: left;

          .goods_card_price {
            display: flex;;
            align-items: center;
            justify-content: space-between;
          }

          .buy-btn-block {
            top: 10px;
            right: 0;
          }
        }

        &.goods-card_align-center {
          text-align: center;

          .goods_card_price {
            flex-direction: column;
            height: auto;

            .buy-btn {
              margin: 5px 0 8px;
            }
          }
        }

        .goods_card_name {
          height: 40px;

          .name {
            .limit-line;
            font-size: 14px;
            margin-bottom: 5px;
            line-height: 20px;
          }

        }

        .goods_card_price {
          position: relative;
          height: 40px;
          display: flex;
          align-items: center;
          padding-top: 5px;

          .price-block {
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;

            .price {
              color: @text-color-price;
            }

            .origin-price {
              margin-left: 6px;
              text-decoration: line-through;
              color: @text-color-gray;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

</style>
